import React from 'react'

import { Card, RewardHistoryStatus } from '@/components'
import { EPayoutType, TWithdrawResult } from '@/libs/apis/mutations/use-post-withdraw-mutation'
import formatCurrency from '@/libs/helpers/format-currency'
import formatDateTime from '@/libs/helpers/format-date-time'

export default function WithdrawReceipt({
  createdAt,
  method,
  provider,
  withdrawnAmount,
  adminFee,
  received,
  status,
  accountNumber,
}: Readonly<TWithdrawResult['result']>) {
  const divClass = 'sentry-mask flex flex-row justify-between'
  const labelClass = 'sentry-mask text-xs font-normal text-pop-grey-900'
  const valueClass = 'sentry-mask text-xs font-normal text-pop-grey-500'

  return (
    <Card noElevation>
      <div className={divClass}>
        <span className={labelClass}>Date & Time</span>
        <span className={valueClass}>{formatDateTime(createdAt)}</span>
      </div>
      <div className={divClass}>
        <span className={labelClass}>Method</span>
        <span className={valueClass}>{method === EPayoutType?.BANK ? 'Bank' : 'E-Wallet'}</span>
      </div>
      <div className={divClass}>
        <span className={labelClass}>Account</span>
        <span className={valueClass}>
          {provider} {accountNumber}
        </span>
      </div>
      <div className={divClass}>
        <span className={labelClass}>Withdrawn Amount</span>
        <span className={valueClass}>Rp{formatCurrency(withdrawnAmount)}</span>
      </div>
      <div className={divClass}>
        <span className={labelClass}>Admin Fee</span>

        <span
          className={`text-xs font-semibold ${
            adminFee === 0 ? 'text-pop-succees' : 'text-pop-red-500'
          }`}
        >
          {adminFee === 0 ? 'Free' : `-Rp${formatCurrency(adminFee)}`}
        </span>
      </div>
      <div className={divClass}>
        <span className={labelClass}>Total</span>
        <span className='text-xs font-semibold text-pop-grey-800'>
          Rp{formatCurrency(received)}
        </span>
      </div>
      <div className={divClass}>
        <span className={labelClass}>Status</span>
        <RewardHistoryStatus status={status} variant='default' />
      </div>
    </Card>
  )
}
